import { safeDefine } from '@breuni-ui/safe-define';
import { CarouselContainer } from '@breuni-ui/carousel';

export default class EntsCarouselContainer extends CarouselContainer {}
safeDefine('ents-carousel-container', EntsCarouselContainer);
